import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ActiveCartService, CartVoucherService } from '@spartacus/cart/base/core';
import { Voucher } from '@spartacus/cart/base/root';
import { ICON_TYPE } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'cx-applied-coupons',
  templateUrl: './applied-coupons.component.html',
  styleUrls: ['./applied-coupons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AppliedCouponsComponent implements OnInit, OnDestroy {
  @Input()
  vouchers: Voucher[];
  @Input()
  cartIsLoading = false;
  @Input()
  isReadOnly = false;

  iconTypes = ICON_TYPE;

  showSrp = false;
  srpSubscription$: Subscription;

  cartId$ = this.cartService.getActiveCartId();
  cartId: any;

  constructor(
    private cartVoucherService: CartVoucherService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    protected cartService: ActiveCartService,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.cartId$.pipe(take(1)).subscribe((results) => {
      this.cartId = results;
    });
    this.getInitSrpToggleValue();

    this.srpSubscription$ = this.componentService.srpToggle$.subscribe((checked) => {
      this.showSrp = checked;
      this.cdr.detectChanges();
    });
  }

  getInitSrpToggleValue() {
    this.showSrp = this.storageService.getLocalStorageItem('showSrp') === 'true';
  }

  public get sortedVouchers(): Voucher[] {
    this.vouchers = this.vouchers || [];
    return this.vouchers.slice().sort((a, b) => {
      return a.code.localeCompare(b.code);
    });
  }

  removeVoucher(voucherId: string, cartId?: string) {
    this.cartVoucherService.removeVoucher(voucherId, cartId);
  }

  ngOnDestroy() {
    if (this.srpSubscription$) {
      this.srpSubscription$.unsubscribe();
    }
  }
}
